import { defineComponent as _defineComponent } from 'vue';
import { BAlert } from "bootstrap-vue";
import { computed } from "vue";
import { useObjectStoreStore } from "@/stores/objectStoreStore";
import { useObjectStoreTemplatesStore } from "@/stores/objectStoreTemplatesStore";
import localize from "@/utils/localization";
import { useInstanceRouting } from "./routing";
import CreateForm from "./CreateForm.vue";
import BreadcrumbHeading from "@/components/Common/BreadcrumbHeading.vue";
import LoadingSpan from "@/components/LoadingSpan.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'CreateInstance',
    props: {
        templateId: null
    },
    setup(__props) {
        const props = __props;
        const { addOrUpdateObjectStore } = useObjectStoreStore();
        const objectStoreTemplatesStore = useObjectStoreTemplatesStore();
        objectStoreTemplatesStore.fetchTemplates();
        const { goToIndex } = useInstanceRouting();
        const template = computed(() => objectStoreTemplatesStore.getLatestTemplate(props.templateId));
        const breadcrumbItems = computed(() => [
            { title: "User Preferences", to: "/user" },
            { title: "Galaxy Storage", to: "/object_store_instances/index" },
            { title: "Create New", to: "/object_store_instances/create" },
            { title: template.value?.name || "Option" },
        ]);
        async function onCreated(objectStore) {
            addOrUpdateObjectStore(objectStore);
            const message = `Created Galaxy storage ${objectStore.name}`;
            goToIndex({ message });
        }
        return { __sfc: true, addOrUpdateObjectStore, objectStoreTemplatesStore, goToIndex, props, template, breadcrumbItems, onCreated, BAlert, localize, CreateForm, BreadcrumbHeading, LoadingSpan };
    }
});
